var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt011ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mlops_color_diamond",
    transform: "translate(-500 -552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    transform: "translate(500 600) rotate(-45)",
    fill: "#ffe8f8",
    stroke: "#db0f9c",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nat_black_24dp",
    transform: "translate(530 580.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1695",
    "data-name": "Group 1695"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    width: 40,
    height: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1697",
    "data-name": "Group 1697",
    transform: "translate(1.667 3.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1696",
    "data-name": "Group 1696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M10.7,15.667h6.967V12.333H10.7a5,5,0,1,0,0,3.333Zm-4.7,0A1.667,1.667,0,1,1,7.667,14,1.672,1.672,0,0,1,6,15.667Z",
    transform: "translate(-1 2.667)",
    fill: "#db0f9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M35,18.667l-6.667-5V17h-6.75A16.664,16.664,0,0,0,5,2V5.333A13.333,13.333,0,0,1,5,32v3.333a16.664,16.664,0,0,0,16.583-15h6.75v3.333Z",
    transform: "translate(1.667 -2)",
    fill: "#db0f9c"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt011ColorDiamond);
export default __webpack_public_path__ + "static/media/PT011_color_diamond.51a26f1004ee100c88e7d1a19ab8b3e6.svg";
export { ForwardRef as ReactComponent };